<template>
  <div class="table-container">
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="24" :xl="24">
        <el-table ref="tableSort" v-loading="loading" :data="list" border>
          <el-table-column label="序号" align="center" width="80" prop="seq">
            <template slot-scope="scope">
              {{ scope.row.seq || "-" }}
            </template>
          </el-table-column>
          <el-table-column prop="stockType" label="股东类型">
            <template slot-scope="scope">
              {{ scope.row.stockType || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="股东姓名" prop="stockName">
            <template slot-scope="scope">
              {{ scope.row.stockName || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="出资比例" width="250" prop="stockPercent">
            <template slot-scope="scope">
              {{ scope.row.stockPercent || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="认缴出资" width="250">
            <template slot-scope="scope">
              {{ scope.row.totalShouldCapi || "-" }}
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!--分页模块-->
    <el-row v-if="total > 0" :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="24" :xl="24">
        <el-card>
          <el-pagination
            :current-page="queryForm.pageNum"
            :page-size="queryForm.pageSize"
            :total="total"
            :background="background"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { getShareholder } from "@/api/workplace/companyInfo";

  export default {
    name: "Shareholder",

    data() {
      return {
        list: [],
        loading: false,
        total: 0,
        background: true,
        layout: "total, sizes, prev, pager, next, jumper",
        queryForm: {
          body: {
            keyword: "",
            seqId: "",
            skip: 0,
          },
          header: {
            currentTime: "",
            requestId: "2b81a030-bf6c-11ea-a387-f8a2d6d9d88d",
            sourceType: "site",
          },
          pageNum: 1,
          pageSize: 20,
        },
        obj: null,
      };
    },

    methods: {
      getShareholder(param) {
        this.loading = true;
        this.obj = param;
        this.queryForm.body.keyword = param.keyword;
        this.queryForm.body.seqId = param.seqId;
        this.queryForm.body.skip = (this.queryForm.pageNum - 1) * 20;
        getShareholder(this.queryForm)
          .then((response) => {
            if (response.header.retCode === "1") {
              this.list = response.body.items;
              this.total = response.body.total;
            }
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
          });
      },
      handleSizeChange(val) {
        this.queryForm.pageSize = val;
        this.getShareholder(this.obj);
      },
      handleCurrentChange(val) {
        this.queryForm.pageNum = val;
        this.getShareholder(this.obj);
      },
    },
  };
</script>

<style scoped></style>
